import { PRESSURE_STATES } from './constants';
export function isCriticalPressure(pressureRecord, state) {
    const record = pressureRecord || state['wildix/features/pressure-observer'].record;
    return record.state === PRESSURE_STATES.CRITICAL;
}
